module.exports = __webpack_public_path__ + "static/media/liquidTherapy.6b4739f3.jpg";